const data = {
  "meta": {
    "title": "2021 Patriots Free Agency Simulator - The Boston Globe",
    "description": "With ample cap space and a No. 15 draft pick, you could remake the roster. Using this simulator, choose among the pool of players and build the best team possible.",
    "author": "Ben Volin",
    "section": "Sports",
    "meter": true,
    "social": true,
    "socialConnect": true,
    "progressBar": false,
    "sectionUrl": "https://www.bostonglobe.com/sports",
    "url": "https://apps.bostonglobe.com/sports/graphics/2021/03/rebuilding-the-new-england-patriots",
    "imageUrl": "https://apps.bostonglobe.com/sports/graphics/2021/03/rebuilding-the-new-england-patriots/images/share.jpg",
    "keywords": "Patriots, New England Patriots, NFL",
    "publishDate": "March 12, 2021",
    "updateDate": "3:00 p.m., March 25, 2021",
  },
  "baseSalary": 55,
  "cap": 20,
  "spent": 0,
  "remaining": 20,
  "overCap": {},
  "selections": {},
  "teamView": true,
  "isFinished": false,
  "finishedView": {},
  "positionFilterHigh": '',
  "positionFilterMedium": '',
  "positionFilterLow": '',
  "positionFilterDraft": '',
  "positionsOfNeed": ["QB", "WR", "DT", "LB", "CB"],
  "reset": false,
  "drafted": '',
  "credits": {
    "author": {
      "role": "Reporter",
      "value": "Ben Volin"
    },
    "editor": {
      "role": "Editor",
      "value": "Katie McInerney"
    },
    "dev": {
      "role": "Design and development",
      "value": "John Hancock"
    },
    "copyediting": {
      "role": "Copy editor",
      "value": "John Carney"
    },
    "photo": {
      "role": "Photo researcher",
      "value": "Chloe Grinberg"
    },
    "stats": {
      "role": "Statistics researcher",
      "value": "Brad Joyal",
    },
    "qa": {
      "role": "Quality assurance",
      "value": "Mark Franchitto"
    }
  },
  "recirc": {
    "recirc1": {
      "head": "A guide to the Patriots offseason: Free-agent decisions, cap space, and plenty of picks in the NFL draft",
      "url": "https://www.bostonglobe.com/2021/03/05/sports/patriots-offseason-guide/",
      "image": "https://www.bostonglobe.com/resizer/o_D3Fbv1F-sVEwRJ6RuUt-Vit8Y=/1024x0/cloudfront-us-east-1.images.arcpublishing.com/bostonglobe/AAOWKTI262Y5X7HDGZCJFBDT5A.jpg"
    },
    "recirc2": {
      "head": "Breaking down the real numbers behind the Patriots’ free agent signings",
      "url": "https://www.bostonglobe.com/2021/03/17/sports/breaking-down-real-numbers-behind-patriots-free-agent-signings/",
      "image": "https://www.bostonglobe.com/resizer/g-GDoCflzjZmErpF7ud2d3RtqcI=/1024x0/cloudfront-us-east-1.images.arcpublishing.com/bostonglobe/V4HS5JGZMODAQ5REKYHZNCEG2A.jpg"
    },
    "recirc3": {
      "head": "Tell us: How would you rebuild the Patriots?",
      "url": "https://www.bostonglobe.com/2021/03/12/sports/tell-us-how-would-you-rebuild-patriots/",
      "image": "https://www.bostonglobe.com/resizer/gLOg79WkR6yeyL5L8nVp0h49i4k=/1440x0/cloudfront-us-east-1.images.arcpublishing.com/bostonglobe/YEF2IABHTBDPVKXZE44WGSSSOE.jpg"
    },
  },
  "signings": [{
      "name": "Cam Newton",
      "position": "QB",
      "deal": "1 year, $13.6 million",
      "story": "https://www.bostonglobe.com/2021/03/12/sports/patriots-re-sign-quarterback-cam-newton-one-year-deal/"
    },
    {
      "name": "Justin Bethel",
      "position": "DB",
      "deal": "3 years, $6 million",
      "story": "https://www.bostonglobe.com/2021/03/12/sports/patriots-will-re-sign-special-teamer-justin-bethel/?p1=Article_Inline_Text_Link"
    },
    {
      "name": "Jonnu Smith",
      "position": "TE",
      "deal": "4 years, $50 million",
      "story": "https://www.bostonglobe.com/2021/03/15/sports/patriots-sign-tight-end-jonnu-smith/?p1=Article_Inline_Text_Link"
    },
    {
      "name": "Davon Godchaux",
      "position": "DT",
      "deal": "2 years, $16 million",
      "story": "https://www.bostonglobe.com/2021/03/15/sports/patriots-sign-free-agent-dt-davon-godchaux-two-year-deal/?p1=Article_Inline_Text_Link"
    },
    {
      "name": "Matt Judon",
      "position": "LB",
      "deal": "4 years, $56.5 million",
      "story": "https://www.bostonglobe.com/2021/03/15/sports/patriots-sign-linebacker-matt-judon-four-year-deal/"
    },
    {
      "name": "Jalen Mills",
      "position": "DB",
      "deal": "4 years, $24 million",
      "story": "https://www.bostonglobe.com/2021/03/15/sports/patriots-sign-defensive-back-jalen-mills/"
    },
    {
      "name": "Deatrich Wise Jr.",
      "position": "DL",
      "deal": "2 years, $30 million",
      "story": "https://www.bostonglobe.com/2021/03/15/sports/patriots-sign-linebacker-matt-judon-four-year-deal/"
    },
    {
      "name": "Nelson Agholor",
      "position": "WR",
      "deal": "2 years, $26 million",
      "story": "https://www.bostonglobe.com/2021/03/15/sports/patriots-reportedly-sign-wr-nelson-agholor/"
    },
    {
      "name": "Kenrick Bourne",
      "position": "WR",
      "deal": "3 years, $22.5 million",
      "story": "https://www.bostonglobe.com/2021/03/15/sports/patriots-reportedly-sign-wr-nelson-agholor/"
    },
    {
      "name": "Henry Anderson",
      "position": "DE",
      "deal": "2 years, $9 million",
      "story": "https://www.bostonglobe.com/2021/03/15/sports/patriots-sign-linebacker-matt-judon-four-year-deal/"
    },
    {
      "name": "Hunter Henry",
      "position": "TE",
      "deal": "3 years, $37.5 million",
      "story": "https://www.bostonglobe.com/2021/03/16/sports/patriots-sign-tight-end-hunter-henry-three-year-deal/"
    },
    {
      "name": "Ted Karras",
      "position": "C",
      "deal": "1 year, $4 million",
      "story": "https://www.bostonglobe.com/2021/03/17/sports/patriots-bringing-back-center-ted-karras-one-year-deal/"
    },
    {
      "name": "Kyle Van Noy",
      "position": "LB",
      "deal": "2 years, $13.2 million",
      "story": "https://www.bostonglobe.com/2021/03/18/sports/patriots-reach-agreement-with-lb-kyle-van-noy/"
    },
    {
      "name": "Montravius Adams",
      "position": "DE",
      "deal": "1 year, $2.5 million",
      "story": "https://www.bostonglobe.com/2021/03/18/sports/patriots-trade-tight-end-ryan-izzo-texans/"
    },
    {
      "name": "David Andrews",
      "position": "C",
      "deal": "4 years, $21 million",
      "story": "https://www.bostonglobe.com/2021/03/19/sports/veteran-center-david-andrews-reportedly-returning-patriots"
    },
    {
      "name": "Nick Folk",
      "position": "K",
      "deal": "1 year, $2.5 million",
      "story": "https://www.bostonglobe.com/2021/03/18/sports/patriots-trade-tight-end-ryan-izzo-texans/"
    },
    {
      "name": "Cody Davis",
      "position": "S",
      "deal": "2 years, $4.5 million",
      "story": "https://www.bostonglobe.com/2020/03/23/sports/patriots-sign-special-teamer-cody-davis/"
    },
    {
      "name": "Raekwon McMillan",
      "position": "LB",
      "deal": "1 year, $1.2 milltion",
      "story": "https://www.bostonglobe.com/2021/03/19/sports/patriots-signing-linebacker-raekwon-mcmillan/"
    },
    {
      "name": "Carl Davis",
      "position": "DT",
      "deal": "1 year, $1.1 million",
      "story": "https://www.bostonglobe.com/2021/03/15/sports/patriots-sign-linebacker-matt-judon-four-year-deal/"
    }
  ],
  "players": {
    "ryanfitzpatrick": {
      "name": "Ryan Fitzpatrick",
      "position": "QB",
      "age": "38",
      "type": "free agent",
      "bucket": "medium",
      "salary": 12,
      "synopsis": "Still playing good ball at 38, and is a terrific leader and mentor. ",
      "stats_2020": "2,091 yards, 13 TDs, 8 INTs",
      "org_2020": "Dolphins",
      "signed": "washington",
      "rfa": "",
      "slug": "ryanfitzpatrick"
    },
    "alexsmith": {
      "name": "Alex Smith",
      "position": "QB",
      "age": "36",
      "type": "free agent",
      "bucket": "medium",
      "salary": 12,
      "synopsis": "Would be a great mentor and backup, but his leg is worrisome.",
      "stats_2020": "1,582 yards, 6 TDs, 8 INTs",
      "org_2020": "Washington",
      "signed": "",
      "rfa": "",
      "slug": "alexsmith"
    },
    "camnewton": {
      "name": "Cam Newton",
      "position": "QB",
      "age": "31",
      "type": "free agent",
      "bucket": "low",
      "salary": 8,
      "synopsis": "Does he have anything left in the tank?",
      "stats_2020": "2,657 yards, 8 TDs, 10 INTs",
      "org_2020": "Patriots",
      "signed": "patriots",
      "rfa": "",
      "slug": "camnewton"
    },
    "tyrodtaylor": {
      "name": "Tyrod Taylor",
      "position": "QB",
      "age": "31",
      "type": "free agent",
      "bucket": "low",
      "salary": 8,
      "synopsis": "Great athlete and locker room presence makes him a top backup.",
      "stats_2020": "208 yards, 0 TDs, 0 INTs",
      "org_2020": "Chargers",
      "signed": "texans",
      "rfa": "",
      "slug": "tyrodtaylor"
    },
    "jacobybrissett": {
      "name": "Jacoby Brissett",
      "position": "QB",
      "age": "28",
      "type": "free agent",
      "bucket": "low",
      "salary": 8,
      "synopsis": "Probably not a full-time starter, but one of the top backups available.",
      "stats_2020": "17 yards, 0 TDs, 0 INTs",
      "org_2020": "Colts",
      "signed": "dolphins",
      "rfa": "",
      "slug": "jacobybrissett"
    },
    "mitchelltrubisky": {
      "name": "Mitchell Trubisky",
      "position": "QB",
      "age": "26",
      "type": "free agent",
      "bucket": "low",
      "salary": 7,
      "synopsis": "Can another coaching staff get more out of him?",
      "stats_2020": "2,055 yards, 16 TDs, 8 INTs",
      "org_2020": "Bears",
      "signed": "bills",
      "rfa": "",
      "slug": "mitchelltrubisky"
    },
    "jameiswinston": {
      "name": "Jameis Winston",
      "position": "QB",
      "age": "27",
      "type": "free agent",
      "bucket": "low",
      "salary": 5,
      "synopsis": "Always had a lot of talent, but throws too many interceptions.",
      "stats_2020": "75 yards, 0 TDs, 0 INTs",
      "org_2020": "Saints",
      "signed": "saints",
      "rfa": "",
      "slug": "jameiswinston"
    },
    "andydalton": {
      "name": "Andy Dalton",
      "position": "QB",
      "age": "33",
      "type": "free agent",
      "bucket": "low",
      "salary": 5,
      "synopsis": "Good in a pinch, but you don\u2019t want him starting more than a few games.  ",
      "stats_2020": "2,170 yards, 14 TDs, 8 INTs",
      "org_2020": "Cowboys",
      "signed": "bears",
      "rfa": "",
      "slug": "andydalton"
    },
    "joeflacco": {
      "name": "Joe Flacco",
      "position": "QB",
      "age": "36",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "Made a few plays last year, could probably help a team with a young QB.",
      "stats_2020": "864 yards, 6 TDs, 3 INTs",
      "org_2020": "Jets",
      "signed": "eagles",
      "rfa": "",
      "slug": "joeflacco"
    },
    "mikeglennon": {
      "name": "Mike Glennon",
      "position": "QB",
      "age": "31",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "Probably just a camp arm.",
      "stats_2020": "1,072 yards, 7 TDs, 5 INTs",
      "org_2020": "Jaguars",
      "signed": "giants",
      "rfa": "",
      "slug": "mikeglennon"
    },
    "chriscarson": {
      "name": "Chris Carson",
      "position": "RB",
      "age": "26",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Bruiser who churns out the tough yards and is valuable in the passing game.",
      "stats_2020": "681 rushing yards, 287 receiving yards, 9 TDs",
      "org_2020": "Seahawks",
      "signed": "seahawks",
      "rfa": "",
      "slug": "chriscarson"
    },
    "aaronjones": {
      "name": "Aaron Jones",
      "position": "RB",
      "age": "26",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Productive dual-purpose back with 30 TDs the last two years still has plenty of tread left.",
      "stats_2020": "1,104 rushing yards,  355 receiving yards, 11 TDs",
      "org_2020": "Packers",
      "signed": "packers",
      "rfa": "",
      "slug": "aaronjones"
    },
    "jamesconner": {
      "name": "James Conner",
      "position": "RB",
      "age": "25",
      "type": "free agent",
      "bucket": "medium",
      "salary": 5,
      "synopsis": "A great three-down back when healthy, but has missed nine games the last two years.",
      "stats_2020": "721 rushing yards, 215 receiving yards, 6 TDs",
      "org_2020": "Steelers",
      "signed": "",
      "rfa": "",
      "slug": "jamesconner"
    },
    "kenyandrake": {
      "name": "Kenyan Drake",
      "position": "RB",
      "age": "27",
      "type": "free agent",
      "bucket": "medium",
      "salary": 5,
      "synopsis": "Coming off solid season with 10 TDs, but mostly a first-down back.",
      "stats_2020": "955 rushing yards, 137 receiving yards, 10 TDs",
      "org_2020": "Cardinals",
      "signed": "raiders",
      "rfa": "",
      "slug": "kenyandrake"
    },
    "dukejohnson": {
      "name": "Duke Johnson",
      "position": "RB",
      "age": "27",
      "type": "free agent",
      "bucket": "medium",
      "salary": 4,
      "synopsis": "A change-of-pace runner who can be effective in spots in the passing game.",
      "stats_2020": "235 rushing yards, 249 receiving yards, 2 TDs",
      "org_2020": "Texans",
      "signed": "",
      "rfa": "",
      "slug": "dukejohnson"
    },
    "mikedavis": {
      "name": "Mike Davis",
      "position": "RB",
      "age": "28",
      "type": "free agent",
      "bucket": "medium",
      "salary": 4,
      "synopsis": "Built like a rock and coming off a career-high 1,015 all-purpose yards.",
      "stats_2020": "642 rushing yards, 373 receiving yards, 8 TDs",
      "org_2020": "Panthers",
      "signed": "falcons",
      "rfa": "",
      "slug": "mikedavis"
    },
    "gusedwards": {
      "name": "Gus Edwards",
      "position": "RB",
      "age": "25",
      "type": "free agent",
      "bucket": "low",
      "salary": 4,
      "synopsis": "A bruising runner who has been a key part of the Ravens\u2019 three-headed rushing attack. ",
      "stats_2020": "723 rushing yards, 129 receiving yards, 6 TDs",
      "org_2020": "Ravens",
      "signed": "",
      "rfa": "x",
      "slug": "gusedwards"
    },
    "philliplindsay": {
      "name": "Phillip Lindsay",
      "position": "RB",
      "age": "26",
      "type": "free agent",
      "bucket": "low",
      "salary": 4,
      "synopsis": "Missed eight games with a knee injury in 2020 but had 1,000 yards in 2018-19.",
      "stats_2020": "502 rushing yards, 7 receiving yards, 1 TDs",
      "org_2020": "Broncos",
      "signed": "texans",
      "rfa": "x",
      "slug": "philliplindsay"
    },
    "jameswhite": {
      "name": "James White",
      "position": "RB",
      "age": "29",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "A key part of the Patriots\u2019 passing game, but will be 29 and is coming off his worst season.",
      "stats_2020": "121 rushing yards, 375 receiving yards, 3 TDs",
      "org_2020": "Patriots",
      "signed": "",
      "rfa": "",
      "slug": "jameswhite"
    },
    "le\u2019veonbell": {
      "name": "Le\u2019Veon Bell",
      "position": "RB",
      "age": "29",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "Maybe worth a flier on a team looking for a veteran backup.",
      "stats_2020": "328 rushing yards, 138 receiving yards, 2 TDs",
      "org_2020": "Chiefs",
      "signed": "",
      "rfa": "",
      "slug": "le\u2019veonbell"
    },
    "rexburkhead": {
      "name": "Rex Burkhead",
      "position": "RB",
      "age": "30",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "Was having a great 2020 season before suffering serious knee injury. ",
      "stats_2020": "274 rushing yards, 192 receiving yards, 6 TDs",
      "org_2020": "Patriots",
      "signed": "",
      "rfa": "",
      "slug": "rexburkhead"
    },
    "marlonmack": {
      "name": "Marlon Mack",
      "position": "RB",
      "age": "25",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "Would be one of the top free agents, but is coming back from a torn Achilles' tendon.",
      "stats_2020": "26 rushing yards, 30 receiving yards, 0 TDs",
      "org_2020": "Colts",
      "signed": "",
      "rfa": "",
      "slug": "marlonmack"
    },
    "kylejuszczyk": {
      "name": "Kyle Juszczyk",
      "position": "FB",
      "age": "29",
      "type": "free agent",
      "bucket": "medium",
      "salary": 5,
      "synopsis": "Has been a great No. 5 receiving threat in Kyle Shanahan\u2019s offense.",
      "stats_2020": "19 receptions",
      "org_2020": "49ers",
      "signed": "49ers",
      "rfa": "",
      "slug": "kylejuszczyk"
    },
    "kennygolladay": {
      "name": "Kenny Golladay",
      "position": "WR",
      "age": "27",
      "type": "free agent",
      "bucket": "high",
      "salary": 17,
      "synopsis": "Big receiver has 21 touchdowns in four seasons and is great in traffic.",
      "stats_2020": "338 receiving yards, 2 TDs, 20 catches",
      "org_2020": "Lions",
      "signed": "giants",
      "rfa": "",
      "slug": "kennygolladay"
    },
    "willfuller": {
      "name": "Will Fuller",
      "position": "WR",
      "age": "26",
      "type": "free agent",
      "bucket": "high",
      "salary": 15,
      "synopsis": "Has speed to burn and averaged career-high 16.6 yards per catch in 2020.",
      "stats_2020": "879 receiving yards, 8 TDs, 53 catches",
      "org_2020": "Texans",
      "signed": "dolphins",
      "rfa": "",
      "slug": "willfuller"
    },
    "jujusmithschuster": {
      "name": "JuJu Smith-Schuster",
      "position": "WR",
      "age": "24",
      "type": "free agent",
      "bucket": "high",
      "salary": 15,
      "synopsis": "Physical, productive, and durable receiver is likely to leave Pittsburgh.",
      "stats_2020": "831 receiving yards, 9 TDs, 97 catches",
      "org_2020": "Steelers",
      "signed": "steelers",
      "rfa": "",
      "slug": "jujusmithschuster"
    },
    "coreydavis": {
      "name": "Corey Davis",
      "position": "WR",
      "age": "26",
      "type": "free agent",
      "bucket": "high",
      "salary": 12,
      "synopsis": "Didn\u2019t quite meet his potential, but had career high in yards and TDs in 2020.",
      "stats_2020": "984 receiving yards, 5 TDs, 65 catches",
      "org_2020": "Titans",
      "signed": "jets",
      "rfa": "",
      "slug": "coreydavis"
    },
    "curtissamuel": {
      "name": "Curtis Samuel",
      "position": "WR",
      "age": "24",
      "type": "free agent",
      "bucket": "high",
      "salary": 11,
      "synopsis": "Do-it-all player who had a career year in 2020.",
      "stats_2020": "851 receiving yards, 3 TDs, 77 catches",
      "org_2020": "Panthers",
      "signed": "",
      "rfa": "",
      "slug": "curtissamuel"
    },
    "ajgreen": {
      "name": "A.J. Green",
      "position": "WR",
      "age": "32",
      "type": "free agent",
      "bucket": "high",
      "salary": 10,
      "synopsis": "May just be a value piece for a team aiming for a Super Bowl.",
      "stats_2020": "523 receiving yards, 2 TDs, 47 catches",
      "org_2020": "Bengals",
      "signed": "cardinals",
      "rfa": "",
      "slug": "ajgreen"
    },
    "tyhilton": {
      "name": "T.Y. Hilton",
      "position": "WR",
      "age": "31",
      "type": "free agent",
      "bucket": "medium",
      "salary": 9,
      "synopsis": "Numbers are starting to slip; will the Colts let him leave?",
      "stats_2020": "762 receiving yards, 5 TDs, 56 catches",
      "org_2020": "Colts",
      "signed": "colts",
      "rfa": "",
      "slug": "tyhilton"
    },
    "nelsonagholor": {
      "name": "Nelson Agholor",
      "position": "WR",
      "age": "27",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Averaged career-high 18.7 yards per catch in impressive 2020.",
      "stats_2020": "896 receiving yards, 8 TDs, 48 catches",
      "org_2020": "Raiders",
      "signed": "patriots",
      "rfa": "",
      "slug": "nelsonagholor"
    },
    "breshadperriman": {
      "name": "Breshad Perriman",
      "position": "WR",
      "age": "27",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Caught nine touchdowns the last two seasons with the Bucs and Jets.",
      "stats_2020": "505 receiving yards, 3 TDs, 30 catches",
      "org_2020": "Jets",
      "signed": "lions",
      "rfa": "",
      "slug": "breshadperriman"
    },
    "goldentate": {
      "name": "Golden Tate",
      "position": "WR",
      "age": "32",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Feisty receiver who may have 1-2 good years left.",
      "stats_2020": "388 receiving yards, 2 TDs, 35 catches",
      "org_2020": "Giants",
      "signed": "",
      "rfa": "",
      "slug": "goldentate"
    },
    "sammywatkins": {
      "name": "Sammy Watkins",
      "position": "WR",
      "age": "27",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Forgotten in Kansas City, he is still young and should have suitors.",
      "stats_2020": "421 receiving yards, 2 TDs, 37 catches",
      "org_2020": "Chiefs",
      "signed": "",
      "rfa": "",
      "slug": "sammywatkins"
    },
    "larryfitzgerald": {
      "name": "Larry Fitzgerald",
      "position": "WR",
      "age": "37",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "It\u2019s either Cardinals or retirement.",
      "stats_2020": "409 receiving yards, 1 TDs, 54 catches",
      "org_2020": "Cardinals",
      "signed": "",
      "rfa": "",
      "slug": "larryfitzgerald"
    },
    "marvinjones": {
      "name": "Marvin Jones",
      "position": "WR",
      "age": "31",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "On the wrong side of 30, but has 18 touchdowns the last two years.",
      "stats_2020": "978 receiving yards, 9 TDs, 76 catches",
      "org_2020": "Lions",
      "signed": "jaguars",
      "rfa": "",
      "slug": "marvinjones"
    },
    "keelancole": {
      "name": "Keelan Cole",
      "position": "WR",
      "age": "27",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Former undrafted player has developed into a solid No. 3.",
      "stats_2020": "642 receiving yards, 5 TDs, 55 catches",
      "org_2020": "Jaguars",
      "signed": "jets",
      "rfa": "",
      "slug": "keelancole"
    },
    "adamhumphries": {
      "name": "Adam Humphries",
      "position": "WR",
      "age": "27",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Was a bust in Tennessee, but still only 28.",
      "stats_2020": "228 receiving yards, 2 TDs, 23 catches",
      "org_2020": "Titans",
      "signed": "",
      "rfa": "",
      "slug": "adamhumphries"
    },
    "deseanjackson": {
      "name": "DeSean Jackson",
      "position": "WR",
      "age": "34",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Will be 35 next year and played in only eight games the last two seasons.",
      "stats_2020": "236 receiving yards, 1 TDs, 14 catches",
      "org_2020": "Eagles",
      "signed": "rams",
      "rfa": "",
      "slug": "deseanjackson"
    },
    "cordarrellepatterson": {
      "name": "Cordarrelle Patterson",
      "position": "WR",
      "age": "30",
      "type": "free agent",
      "bucket": "medium",
      "salary": 5,
      "synopsis": "Still one of the NFL\u2019s best kickoff returners and a Swiss Army knife on offense.",
      "stats_2020": "132 receiving yards, 0 TDs, 21 catches",
      "org_2020": "Bears",
      "signed": "",
      "rfa": "",
      "slug": "cordarrellepatterson"
    },
    "rashardhiggins": {
      "name": "Rashard Higgins",
      "position": "WR",
      "age": "26",
      "type": "free agent",
      "bucket": "low",
      "salary": 4,
      "synopsis": "Averaged a healthy 16.2 yards per catch last year. ",
      "stats_2020": "599 receiving yards, 4 TDs, 37 catches",
      "org_2020": "Browns",
      "signed": "",
      "rfa": "",
      "slug": "rashardhiggins"
    },
    "antoniobrown": {
      "name": "Antonio Brown",
      "position": "WR",
      "age": "32",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "Hard to see him going anywhere but Tampa Bay",
      "stats_2020": "483 receiving yards, 4 TDs, 45 catches",
      "org_2020": "Buccaneers",
      "signed": "",
      "rfa": "",
      "slug": "antoniobrown"
    },
    "kennystills": {
      "name": "Kenny Stills",
      "position": "WR",
      "age": "28",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "Just a fourth or fifth receiver at this point.",
      "stats_2020": "144 receiving yards, 1 TDs, 11 catches",
      "org_2020": "Texans",
      "signed": "",
      "rfa": "",
      "slug": "kennystills"
    },
    "dannyamendola": {
      "name": "Danny Amendola",
      "position": "WR",
      "age": "35",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "Made it 12 years in the NFL, but this may be the end of the line.",
      "stats_2020": "602 receiving yards, 0 TDs, 46 catches",
      "org_2020": "Lions",
      "signed": "",
      "rfa": "",
      "slug": "dannyamendola"
    },
    "williesnead": {
      "name": "Willie Snead",
      "position": "WR",
      "age": "28",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "Won\u2019t break the bank and could provide good value at slot receiver.",
      "stats_2020": "432 receiving yards, 3 TDs, 33 catches",
      "org_2020": "Ravens",
      "signed": "",
      "rfa": "",
      "slug": "williesnead"
    },
    "damierebyrd": {
      "name": "Damiere Byrd",
      "position": "WR",
      "age": "28",
      "type": "free agent",
      "bucket": "low",
      "salary": 2,
      "synopsis": "Didn\u2019t have much production but played a lot of snaps in 2020.",
      "stats_2020": "604 receiving yards, 1 TDs, 47 catches",
      "org_2020": "Patriots",
      "signed": "",
      "rfa": "",
      "slug": "damierebyrd"
    },
    "hunterhenry": {
      "name": "Hunter Henry",
      "position": "TE",
      "age": "26",
      "type": "free agent",
      "bucket": "high",
      "salary": 14,
      "synopsis": "Athletic receiver with 21 career TDs but also a troubling injury history.",
      "stats_2020": "613 receiving yards, 4 TDs, 60 catches",
      "org_2020": "Chargers",
      "signed": "patriots",
      "rfa": "",
      "slug": "hunterhenry"
    },
    "jonnusmith": {
      "name": "Jonnu Smith",
      "position": "TE",
      "age": "25",
      "type": "free agent",
      "bucket": "high",
      "salary": 13,
      "synopsis": "His career highs are only 41 catches and 448 yards, but he is athletic and durable. ",
      "stats_2020": "448 receiving yards, 8 TDs, 41 catches",
      "org_2020": "Titans",
      "signed": "patriots",
      "rfa": "",
      "slug": "jonnusmith"
    },
    "geraldeverett": {
      "name": "Gerald Everett",
      "position": "TE",
      "age": "26",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Has been a solid fourth option for the Rams, improving his stats every year.",
      "stats_2020": "417 receiving yards, 1 TDs, 41 catches",
      "org_2020": "Rams",
      "signed": "",
      "rfa": "",
      "slug": "geraldeverett"
    },
    "kylerudolph": {
      "name": "Kyle Rudolph",
      "position": "TE",
      "age": "31",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Ten-year veteran is probably just a part-time player at this point.",
      "stats_2020": "334 receiving yards, 1 TDs, 28 catches",
      "org_2020": "Vikings",
      "signed": "giants",
      "rfa": "",
      "slug": "kylerudolph"
    },
    "robgronkowski": {
      "name": "Rob Gronkowski",
      "position": "TE",
      "age": "31",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Would be shocking if he didn\u2019t return to Tampa Bay.",
      "stats_2020": "623 receiving yards, 7 TDs, 45 catches",
      "org_2020": "Buccaneers",
      "signed": "buccaneers",
      "rfa": "",
      "slug": "robgronkowski"
    },
    "jaredcook": {
      "name": "Jared Cook",
      "position": "TE",
      "age": "33",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Numbers were down in his 12th year, but he can still produce in the red zone.",
      "stats_2020": "504 receiving yards, 7 TDs, 37 catches",
      "org_2020": "Saints",
      "signed": "chargers",
      "rfa": "",
      "slug": "jaredcook"
    },
    "treyburton": {
      "name": "Trey Burton",
      "position": "TE",
      "age": "29",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Philly Super Bowl hero has had a tough time staying healthy and productive.",
      "stats_2020": "250 receiving yards, 3 TDs, 28 catches",
      "org_2020": "Bears",
      "signed": "",
      "rfa": "",
      "slug": "treyburton"
    },
    "anthonyfirkser": {
      "name": "Anthony Firkser",
      "position": "TE",
      "age": "26",
      "type": "free agent",
      "bucket": "low",
      "salary": 4,
      "synopsis": "Solid No. 2-3 tight end and special teamer who can play the H-back role.",
      "stats_2020": "387 receiving yards, 1 TDs, 39 catches",
      "org_2020": "Titans",
      "signed": "",
      "rfa": "x",
      "slug": "anthonyfirkser"
    },
    "roberttonyan": {
      "name": "Robert Tonyan",
      "position": "TE",
      "age": "26",
      "type": "free agent",
      "bucket": "low",
      "salary": 5,
      "synopsis": "Had a huge breakout season in 2020; it will take a first-round pick to pry him away.",
      "stats_2020": "587 receiving yards, 11 TDs, 52 catches",
      "org_2020": "Packers",
      "signed": "",
      "rfa": "x",
      "slug": "roberttonyan"
    },
    "moaliecox": {
      "name": "Mo Alie-Cox",
      "position": "TE",
      "age": "27",
      "type": "free agent",
      "bucket": "low",
      "salary": 4,
      "synopsis": "Developed into a solid No. 2 tight end in 2020.",
      "stats_2020": "394 receiving yards, 2 TDs, 31 catches",
      "org_2020": "Colts",
      "signed": "",
      "rfa": "x",
      "slug": "moaliecox"
    },
    "jacobhollister": {
      "name": "Jacob Hollister",
      "position": "TE",
      "age": "27",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "Doesn\u2019t make many plays, but always seems to make big ones.",
      "stats_2020": "209 receiving yards, 3 TDs, 25 catches",
      "org_2020": "Seahawks",
      "signed": "",
      "rfa": "",
      "slug": "jacobhollister"
    },
    "danarnold": {
      "name": "Dan Arnold",
      "position": "TE",
      "age": "26",
      "type": "free agent",
      "bucket": "low",
      "salary": 2,
      "synopsis": "Finally got an opportunity in 2020 and made the most of it; intriguing, athletic pass-catcher.",
      "stats_2020": "438 receiving yards, 4 TDs, 31 catches",
      "org_2020": "Cardinals",
      "signed": "",
      "rfa": "",
      "slug": "danarnold"
    },
    "trentwilliams": {
      "name": "Trent Williams",
      "position": "OT",
      "age": "32",
      "type": "free agent",
      "bucket": "high",
      "salary": 20,
      "synopsis": "Still an elite left tackle and should score a huge payday.",
      "stats_2020": "14 games, 14 starts",
      "org_2020": "49ers",
      "signed": "49ers",
      "rfa": "",
      "slug": "trentwilliams"
    },
    "alejandrovillanueva": {
      "name": "Alejandro Villanueva",
      "position": "OT",
      "age": "32",
      "type": "free agent",
      "bucket": "high",
      "salary": 13,
      "synopsis": "Has started 97 consecutive games and committed just 4 penalties last year.",
      "stats_2020": "16 games, 16 starts",
      "org_2020": "Steelers",
      "signed": "",
      "rfa": "",
      "slug": "alejandrovillanueva"
    },
    "russellokung": {
      "name": "Russell Okung",
      "position": "OT",
      "age": "32",
      "type": "free agent",
      "bucket": "high",
      "salary": 11,
      "synopsis": "Still great when healthy, but has played only 13 games the last two years. ",
      "stats_2020": "7 games, 7 starts",
      "org_2020": "Panthers",
      "signed": "",
      "rfa": "",
      "slug": "russellokung"
    },
    "darylwilliams": {
      "name": "Daryl Williams",
      "position": "OT",
      "age": "28",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Started 16 games last year and committed only one holding penalty.",
      "stats_2020": "16 games, 16 starts",
      "org_2020": "Bills",
      "signed": "bills",
      "rfa": "",
      "slug": "darylwilliams"
    },
    "rickwagner": {
      "name": "Rick Wagner",
      "position": "OT",
      "age": "31",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Started nine games last year and may be more of a backup option.",
      "stats_2020": "16 games, 9 starts",
      "org_2020": "Packers",
      "signed": "",
      "rfa": "",
      "slug": "rickwagner"
    },
    "mikeremmers": {
      "name": "Mike Remmers",
      "position": "OT",
      "age": "31",
      "type": "free agent",
      "bucket": "medium",
      "salary": 5,
      "synopsis": "Nine-year journeyman can still get it done as a backup tackle or guard.",
      "stats_2020": "13 games, 10 starts",
      "org_2020": "Panthers",
      "signed": "",
      "rfa": "",
      "slug": "mikeremmers"
    },
    "kelvinbeachum": {
      "name": "Kelvin Beachum",
      "position": "OT",
      "age": "31",
      "type": "free agent",
      "bucket": "low",
      "salary": 5,
      "synopsis": "Nine-year veteran played every snap and had a solid rebound year in 2020.",
      "stats_2020": "16 games, 16 starts",
      "org_2020": "Cardinals",
      "signed": "cardinals",
      "rfa": "",
      "slug": "kelvinbeachum"
    },
    "mattfeiler": {
      "name": "Matt Feiler",
      "position": "OT",
      "age": "28",
      "type": "free agent",
      "bucket": "medium",
      "salary": 5,
      "synopsis": "Started 40 games the past three seasons at right tackle.",
      "stats_2020": "13 games, 13 starts",
      "org_2020": "Steelers",
      "signed": "chargers",
      "rfa": "",
      "slug": "mattfeiler"
    },
    "joethuney": {
      "name": "Joe Thuney",
      "position": "G/C",
      "age": "28",
      "type": "free agent",
      "bucket": "high",
      "salary": 17,
      "synopsis": "Has never missed a start and barely a snap in five seasons; will get a huge contract.",
      "stats_2020": "16 games, 16 starts",
      "org_2020": "Patriots",
      "signed": "chiefs",
      "rfa": "",
      "slug": "joethuney"
    },
    "coreylinsley": {
      "name": "Corey Linsley",
      "position": "G/C",
      "age": "29",
      "type": "free agent",
      "bucket": "medium",
      "salary": 9,
      "synopsis": "Durable and dependable center didn\u2019t commit a penalty in 2020.",
      "stats_2020": "13 games, 13 starts",
      "org_2020": "Packers",
      "signed": "chargers",
      "rfa": "",
      "slug": "coreylinsley"
    },
    "davidandrews": {
      "name": "David Andrews",
      "position": "G/C",
      "age": "28",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Anchor of the Patriots\u2019 offensive line should have a few years left.",
      "stats_2020": "12 games, 12 starts",
      "org_2020": "Patriots",
      "signed": "patriots",
      "rfa": "",
      "slug": "davidandrews"
    },
    "nickmartin": {
      "name": "Nick Martin",
      "position": "G/C",
      "age": "27",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Dependable center has played every snap in two of the past three seasons.",
      "stats_2020": "16 games, 16 starts",
      "org_2020": "Texans",
      "signed": "",
      "rfa": "",
      "slug": "nickmartin"
    },
    "tedkarras": {
      "name": "Ted Karras",
      "position": "G/C",
      "age": "28",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Played 100 percent of snaps in 2020 and should score a nice contract.",
      "stats_2020": "16 games, 16 starts",
      "org_2020": "Dolphins",
      "signed": "patriots",
      "rfa": "",
      "slug": "tedkarras"
    },
    "alexmack": {
      "name": "Alex Mack",
      "position": "G/C",
      "age": "35",
      "type": "free agent",
      "bucket": "low",
      "salary": 5,
      "synopsis": "Five-time Pro Bowler started 14 games last year but will be 36 next season.",
      "stats_2020": "14 games, 14 starts",
      "org_2020": "Falcons",
      "signed": "49ers",
      "rfa": "",
      "slug": "alexmack"
    },
    "austinreiter": {
      "name": "Austin Reiter",
      "position": "G/C",
      "age": "29",
      "type": "free agent",
      "bucket": "low",
      "salary": 4,
      "synopsis": "A dependable center who started 34 games the past two years.  ",
      "stats_2020": "15 games, 12 starts",
      "org_2020": "Chiefs",
      "signed": "",
      "rfa": "",
      "slug": "austinreiter"
    },
    "shelbyharris": {
      "name": "Shelby Harris",
      "position": "DT",
      "age": "29",
      "type": "free agent",
      "bucket": "high",
      "salary": 12,
      "synopsis": "Solid first- and second-down defender who can play up and down the line.",
      "stats_2020": "32 tackles, 2.5 sacks, 1 forced fumble",
      "org_2020": "Broncos",
      "signed": "broncos",
      "rfa": "",
      "slug": "shelbyharris"
    },
    "dalvintomlinson": {
      "name": "Dalvin Tomlinson",
      "position": "DT",
      "age": "27",
      "type": "free agent",
      "bucket": "high",
      "salary": 10,
      "synopsis": "A stout presence in the middle who hasn\u2019t missed a start in four years.",
      "stats_2020": "49 tackles, 3.5 sacks, 0 forced fumbles",
      "org_2020": "Giants",
      "signed": "vikings",
      "rfa": "",
      "slug": "dalvintomlinson"
    },
    "kawannshort": {
      "name": "Kawann Short",
      "position": "DT",
      "age": "32",
      "type": "free agent",
      "bucket": "high",
      "salary": 10,
      "synopsis": "Has played in only five games the past two seasons combined.",
      "stats_2020": "6 tackles, 0 sacks, 0 forced fumbles",
      "org_2020": "Panthers",
      "signed": "",
      "rfa": "",
      "slug": "kawannshort"
    },
    "ndamukongsuh": {
      "name": "Ndamukong Suh",
      "position": "DT",
      "age": "34",
      "type": "free agent",
      "bucket": "high",
      "salary": 10,
      "synopsis": "Hasn\u2019t missed a game in a decade and still a nasty presence in the middle.",
      "stats_2020": "44 tackles, 6 sacks, 1 forced fumble",
      "org_2020": "Buccaneers",
      "signed": "buccaneers",
      "rfa": "",
      "slug": "ndamukongsuh"
    },
    "adambutler": {
      "name": "Adam Butler",
      "position": "DT",
      "age": "26",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Has 15 sacks in four seasons and may price himself out of New England.",
      "stats_2020": "34 tackles, 4 sacks, 0 forced fumbles",
      "org_2020": "Patriots",
      "signed": "dolphins",
      "rfa": "",
      "slug": "adambutler"
    },
    "daquanjones": {
      "name": "DaQuan Jones",
      "position": "DT",
      "age": "29",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Not the flashiest player but has started 16 games in five of last six years.",
      "stats_2020": "49 tackles, 2 sacks, 1 forced fumble",
      "org_2020": "Titans",
      "signed": "",
      "rfa": "",
      "slug": "daquanjones"
    },
    "jurrellcasey": {
      "name": "Jurrell Casey",
      "position": "DT",
      "age": "31",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Was extremely durable and productive for nine years before injuries hit in 2020.",
      "stats_2020": "14 tackles, 0 sacks, 0 forced fumbles",
      "org_2020": "Broncos",
      "signed": "",
      "rfa": "",
      "slug": "jurrellcasey"
    },
    "tysonalualu": {
      "name": "Tyson Alualu",
      "position": "DT",
      "age": "33",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Entering his 12th season and still gets a lot of the dirty work done.",
      "stats_2020": "39 tackles, 2 sacks, 1 forced fumble",
      "org_2020": "Steelers",
      "signed": "",
      "rfa": "",
      "slug": "tysonalualu"
    },
    "lawrenceguy": {
      "name": "Lawrence Guy",
      "position": "DT",
      "age": "31",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Has been one of the Patriots\u2019 most consistent defenders the last three years.",
      "stats_2020": "57 tackles, 2 sacks, 0 forced fumbles",
      "org_2020": "Patriots",
      "signed": "",
      "rfa": "",
      "slug": "lawrenceguy"
    },
    "sheldonrankins": {
      "name": "Sheldon Rankins",
      "position": "DT",
      "age": "26",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Went from a starter to a sub role the last two years in New Orleans.",
      "stats_2020": "20 tackles, 1.5 sacks, 0 forced fumbles",
      "org_2020": "Saints",
      "signed": "",
      "rfa": "",
      "slug": "sheldonrankins"
    },
    "larryogunjobi": {
      "name": "Larry Ogunjobi",
      "position": "DT",
      "age": "26",
      "type": "free agent",
      "bucket": "medium",
      "salary": 5,
      "synopsis": "Disruptive pass rusher in the middle who has been durable the last three years. ",
      "stats_2020": "46 tackles, 2.5 sacks, 1 forced fumble",
      "org_2020": "Browns",
      "signed": "",
      "rfa": "",
      "slug": "larryogunjobi"
    },
    "shaqbarrett": {
      "name": "Shaq Barrett",
      "position": "DE/OLB",
      "age": "28",
      "type": "free agent",
      "bucket": "high",
      "salary": 19,
      "synopsis": "Star of the Bucs\u2019 playoff run is primed for a major payday.",
      "stats_2020": "57 tackles, 8 sacks, 2 forced fumbles",
      "org_2020": "Buccaneers",
      "signed": "buccaneers",
      "rfa": "",
      "slug": "shaqbarrett"
    },
    "carllawson": {
      "name": "Carl Lawson",
      "position": "DE/OLB",
      "age": "25",
      "type": "free agent",
      "bucket": "high",
      "salary": 15,
      "synopsis": "Not as productive as other pass rushers but just entering his prime.",
      "stats_2020": "36 tackles, 5.5 sacks, 2 forced fumbles",
      "org_2020": "Bengals",
      "signed": "jets",
      "rfa": "",
      "slug": "carllawson"
    },
    "yannickngakoue": {
      "name": "Yannick Ngakoue",
      "position": "DE/OLB",
      "age": "25",
      "type": "free agent",
      "bucket": "high",
      "salary": 14,
      "synopsis": "Has 45.5 sacks in five years and is a top edge rusher.",
      "stats_2020": "23 tackles, 8 sacks, 4 forced fumbles",
      "org_2020": "Ravens",
      "signed": "raiders",
      "rfa": "",
      "slug": "yannickngakoue"
    },
    "matthewjudon": {
      "name": "Matthew Judon",
      "position": "DE/OLB",
      "age": "28",
      "type": "free agent",
      "bucket": "high",
      "salary": 14,
      "synopsis": "Has never been a big sack guy, but a good, physical, three-down player.",
      "stats_2020": "50 tackles, 6 sacks, 0 forced fumbles",
      "org_2020": "Ravens",
      "signed": "patriots",
      "rfa": "",
      "slug": "matthewjudon"
    },
    "jadeveonclowney": {
      "name": "Jadeveon Clowney",
      "position": "DE/OLB",
      "age": "28",
      "type": "free agent",
      "bucket": "high",
      "salary": 13,
      "synopsis": "Only eight games and zero sacks last year, but still great against the run.",
      "stats_2020": "19 tackles, 0 sacks, 1 forced fumble",
      "org_2020": "Titans",
      "signed": "",
      "rfa": "",
      "slug": "jadeveonclowney"
    },
    "treyhendrickson": {
      "name": "Trey Hendrickson",
      "position": "DE/OLB",
      "age": "26",
      "type": "free agent",
      "bucket": "high",
      "salary": 11,
      "synopsis": "Had 13.5 sacks in breakout 2020 season and is ready for a bigger role.",
      "stats_2020": "25 tackles, 13.5 sacks, 1 forced fumble",
      "org_2020": "Saints",
      "signed": "bengals",
      "rfa": "",
      "slug": "treyhendrickson"
    },
    "carlosdunlap": {
      "name": "Carlos Dunlap",
      "position": "DE/OLB",
      "age": "32",
      "type": "free agent",
      "bucket": "high",
      "salary": 11,
      "synopsis": "Productive edge rusher who can still wreck a game.",
      "stats_2020": "32 tackles, 6.0 sacks, 0 forced fumbles",
      "org_2020": "Seahawks",
      "signed": "",
      "rfa": "",
      "slug": "carlosdunlap"
    },
    "buddupree": {
      "name": "Bud Dupree",
      "position": "DE/OLB",
      "age": "28",
      "type": "free agent",
      "bucket": "high",
      "salary": 10,
      "synopsis": "Hasn\u2019t quite been a menace off the edge but still a productive player.",
      "stats_2020": "31 tackles, 8 sacks, 2 forced fumbles",
      "org_2020": "Steelers",
      "signed": "titans",
      "rfa": "",
      "slug": "buddupree"
    },
    "melviningram": {
      "name": "Melvin Ingram",
      "position": "DE/OLB",
      "age": "31",
      "type": "free agent",
      "bucket": "high",
      "salary": 10,
      "synopsis": "Played only seven games and will be 32, but should have 1-2 good years left.",
      "stats_2020": "10 tackles, 0 sacks, 0 forced fumbles",
      "org_2020": "Chargers",
      "signed": "",
      "rfa": "",
      "slug": "melviningram"
    },
    "leonardfloyd": {
      "name": "Leonard Floyd",
      "position": "DE/OLB",
      "age": "28",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Coming off career highs in tackles and sacks and hasn\u2019t missed a game in four years.",
      "stats_2020": "55 tackles, 10.5 sacks, 1 forced fumble",
      "org_2020": "Rams",
      "signed": "rams",
      "rfa": "",
      "slug": "leonardfloyd"
    },
    "justinhouston": {
      "name": "Justin Houston",
      "position": "DE/OLB",
      "age": "32",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Entering his 11th year but still productive, with 28 sacks the last three years.",
      "stats_2020": "25 tackles, 8 sacks, 1 forced fumble",
      "org_2020": "Colts",
      "signed": "",
      "rfa": "",
      "slug": "justinhouston"
    },
    "romeookwara": {
      "name": "Romeo Okwara",
      "position": "DE/OLB",
      "age": "25",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Had a breakout year with 10 sacks, half of his career total.",
      "stats_2020": "44 tackles, 10 sacks, 3 forced fumbles",
      "org_2020": "Lions",
      "signed": "lions",
      "rfa": "",
      "slug": "romeookwara"
    },
    "tyusbowser": {
      "name": "Tyus Bowser",
      "position": "DE/OLB",
      "age": "25",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Started only two games in four years but is a good third-down edge rusher.",
      "stats_2020": "34 tackles, 2 sacks, 0 forced fumbles",
      "org_2020": "Ravens",
      "signed": "ravens",
      "rfa": "",
      "slug": "tyusbowser"
    },
    "deatrichwisejr": {
      "name": "Deatrich Wise Jr.",
      "position": "DE/OLB",
      "age": "26",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Big and physical player who may be ready for a bigger role.",
      "stats_2020": "49 tackles, 2.5 sacks, 0 forced fumbles",
      "org_2020": "Patriots",
      "signed": "patriots",
      "rfa": "",
      "slug": "deatrichwisejr"
    },
    "haasonreddick": {
      "name": "Haason Reddick",
      "position": "DE/OLB",
      "age": "20",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Had career-high 12.5 sacks, but 5 came in one game.",
      "stats_2020": "63 tackles, 12.5 sacks, 6 forced fumbles",
      "org_2020": "Cardinals",
      "signed": "panthers",
      "rfa": "",
      "slug": "haasonreddick"
    },
    "oliviervernon": {
      "name": "Olivier Vernon",
      "position": "DE/OLB",
      "age": "30",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Has durability issues but still an elite athlete and pass rusher.",
      "stats_2020": "36 tackles, 9 sacks, 1 forced fumble",
      "org_2020": "Browns",
      "signed": "",
      "rfa": "",
      "slug": "oliviervernon"
    },
    "denicoautry": {
      "name": "Denico Autry",
      "position": "DE/OLB",
      "age": "30",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Good situational pass rusher who had 7.5 sacks last year.",
      "stats_2020": "33 tackles, 7.5 sacks, 0 forced fumbles",
      "org_2020": "Colts",
      "signed": "titans",
      "rfa": "",
      "slug": "denicoautry"
    },
    "derekwolfe": {
      "name": "Derek Wolfe",
      "position": "DE/OLB",
      "age": "31",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Not a big pass rusher but stout against the run and good for a sub role.",
      "stats_2020": "51 tackles,1 sack, 0 forced fumbles",
      "org_2020": "Ravens",
      "signed": "ravens",
      "rfa": "",
      "slug": "derekwolfe"
    },
    "takkmckinley": {
      "name": "Takk McKinley",
      "position": "DE/OLB",
      "age": "25",
      "type": "free agent",
      "bucket": "low",
      "salary": 5,
      "synopsis": "Had a strange injury situation last year and played only four games.",
      "stats_2020": "8 tackles, 1 sack, 0 forced fumbles",
      "org_2020": "Raiders",
      "signed": "browns",
      "rfa": "",
      "slug": "takkmckinley"
    },
    "aldonsmith": {
      "name": "Aldon Smith",
      "position": "DE/OLB",
      "age": "31",
      "type": "free agent",
      "bucket": "low",
      "salary": 5,
      "synopsis": "Played 16 games last year and got his career back on track.",
      "stats_2020": "48 tackles, 5 sacks, 0 forced fumbles",
      "org_2020": "Cowboys",
      "signed": "",
      "rfa": "",
      "slug": "aldonsmith"
    },
    "jordanjenkins": {
      "name": "Jordan Jenkins",
      "position": "DE/OLB",
      "age": "26",
      "type": "free agent",
      "bucket": "low",
      "salary": 5,
      "synopsis": "Production dropped significantly in 2020; potentially could use a change of scenery.",
      "stats_2020": "32 tackles, 2 sacks, 1 forced fumble",
      "org_2020": "Jets",
      "signed": "",
      "rfa": "",
      "slug": "jordanjenkins"
    },
    "henryanderson": {
      "name": "Henry Anderson",
      "position": "DE/OLB",
      "age": "26",
      "type": "free agent",
      "bucket": "medium",
      "salary": 5,
      "synopsis": "Productive run-stuffer who won\u2019t break the bank.",
      "stats_2020": "42 tackles, 0.5 sacks, 0 forced fumbles",
      "org_2020": "Jets",
      "signed": "patriots",
      "rfa": "",
      "slug": "henryanderson"
    },
    "mattmilano": {
      "name": "Matt Milano",
      "position": "LB",
      "age": "26",
      "type": "free agent",
      "bucket": "high",
      "salary": 12,
      "synopsis": "Former BC Eagle struggled with two injuries in 2020 but is great when healthy.",
      "stats_2020": "45 tackles, 3.5 sacks, 0 forced fumbles",
      "org_2020": "Bills",
      "signed": "bills",
      "rfa": "",
      "slug": "mattmilano"
    },
    "kylevannoy": {
      "name": "Kyle Van Noy",
      "position": "LB",
      "age": "29",
      "type": "free agent",
      "bucket": "medium",
      "salary": 9,
      "synopsis": "A surprise cut by the Dolphins; still has plenty of football left in the tank.",
      "stats_2020": "69 tackles, 6 sacks, 2 forced fumbles",
      "org_2020": "Dolphins",
      "signed": "patriots",
      "rfa": "",
      "slug": "kylevannoy"
    },
    "kjwright": {
      "name": "K.J. Wright",
      "position": "LB",
      "age": "31",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "One of the last active members of the Seahawks Super Bowl teams is still a top linebacker.",
      "stats_2020": "86 tackles, 2 sacks, 1 forced fumble",
      "org_2020": "Seahawks",
      "signed": "",
      "rfa": "",
      "slug": "kjwright"
    },
    "jayonbrown": {
      "name": "Jayon Brown",
      "position": "LB",
      "age": "26",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Played in only 10 games last year but has great speed and instincts.",
      "stats_2020": "76 tackles, 1 sack, 2 forced fumbles",
      "org_2020": "Titans",
      "signed": "titans",
      "rfa": "",
      "slug": "jayonbrown"
    },
    "denzelperryman": {
      "name": "Denzel Perryman",
      "position": "LB",
      "age": "28",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Doesn\u2019t do much in pass coverage but solid in run coverage and a good depth player.",
      "stats_2020": "48 tackles, 1 sack, 1 forced fumble",
      "org_2020": "Chargers",
      "signed": "panthers",
      "rfa": "",
      "slug": "denzelperryman"
    },
    "williamjacksoniii": {
      "name": "William Jackson III",
      "position": "CB",
      "age": "28",
      "type": "free agent",
      "bucket": "high",
      "salary": 13,
      "synopsis": "Hasn\u2019t made a huge impact, but consistent, durable cornerbacks get paid.",
      "stats_2020": "45 tackles, 1 INT, 11 pass breakups",
      "org_2020": "Bengals",
      "signed": "washington",
      "rfa": "",
      "slug": "williamjacksoniii"
    },
    "mikehilton": {
      "name": "Mike Hilton",
      "position": "CB",
      "age": "27",
      "type": "free agent",
      "bucket": "medium",
      "salary": 9,
      "synopsis": "A durable slot cornerback who has seven career interceptions and 9.5 sacks.",
      "stats_2020": "51 tackles, 3 INTs, 7 pass breakups",
      "org_2020": "Steelers",
      "signed": "bengals",
      "rfa": "",
      "slug": "mikehilton"
    },
    "desmondtrufant": {
      "name": "Desmond Trufant",
      "position": "CB",
      "age": "30",
      "type": "free agent",
      "bucket": "medium",
      "salary": 9,
      "synopsis": "Battled injuries and played only 15 games the last two years.",
      "stats_2020": "20 tackles, 1 INT, 4 pass breakups",
      "org_2020": "Lions",
      "signed": "bears",
      "rfa": "",
      "slug": "desmondtrufant"
    },
    "patrickpeterson": {
      "name": "Patrick Peterson",
      "position": "CB",
      "age": "30",
      "type": "free agent",
      "bucket": "medium",
      "salary": 9,
      "synopsis": "Unclear if the Cardinals want the future Hall of Famer to finish his career in Arizona.",
      "stats_2020": "61 tackles, 3 INTs, 8 pass breakups",
      "org_2020": "Cardinals",
      "signed": "",
      "rfa": "",
      "slug": "patrickpeterson"
    },
    "richardsherman": {
      "name": "Richard Sherman",
      "position": "CB",
      "age": "32",
      "type": "free agent",
      "bucket": "medium",
      "salary": 9,
      "synopsis": "Would fit only in the right scheme, but should have 1-2 good years left.",
      "stats_2020": "18 tackles, 1 INT, 1 pass breakup",
      "org_2020": "49ers",
      "signed": "",
      "rfa": "",
      "slug": "richardsherman"
    },
    "desmondking": {
      "name": "Desmond King",
      "position": "CB",
      "age": "26",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "A durable slot cornerback who has good kick-return skills.",
      "stats_2020": "55 tackles, 0 INTs, 2 pass breakups",
      "org_2020": "Chargers",
      "signed": "texans",
      "rfa": "",
      "slug": "desmondking"
    },
    "ajbouye": {
      "name": "A.J. Bouye",
      "position": "CB",
      "age": "29",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Can still be a productive player and a veteran leader in a zone-based defense.",
      "stats_2020": "23 tackles, 0 INTs, 6 pass breakups",
      "org_2020": "Broncos",
      "signed": "",
      "rfa": "",
      "slug": "ajbouye"
    },
    "shaquillgriffin": {
      "name": "Shaquill Griffin",
      "position": "CB",
      "age": "25",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Physical cornerback who would be a good fit in any Cover 3 scheme.",
      "stats_2020": "63 tackles, 3 INTs, 12 pass breakups",
      "org_2020": "Seahawks",
      "signed": "jaguars",
      "rfa": "",
      "slug": "shaquillgriffin"
    },
    "malcolmbutler": {
      "name": "Malcolm Butler",
      "position": "CB",
      "age": "31",
      "type": "free agent",
      "bucket": "medium",
      "salary": 8,
      "synopsis": "Still played well in 2020 and should have a healthy market.",
      "stats_2020": "100 tackles, 4 INTs, 14 pass breakups",
      "org_2020": "Titans",
      "signed": "cardinals",
      "rfa": "",
      "slug": "malcolmbutler"
    },
    "chidobeawuzie": {
      "name": "Chidobe Awuzie",
      "position": "CB",
      "age": "25",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Limited to eight games with a hamstring injury in 2020, but has great size and athleticism. ",
      "stats_2020": "38 tackles, 1 INT, 5 pass breakups",
      "org_2020": "Cowboys",
      "signed": "bengals",
      "rfa": "",
      "slug": "chidobeawuzie"
    },
    "brianpoole": {
      "name": "Brian Poole",
      "position": "CB",
      "age": "28",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Missed nine games the last two years but can play slot corner or safety.",
      "stats_2020": "44 tackles, 2 INTs, 7 pass breakups",
      "org_2020": "Jets",
      "signed": "",
      "rfa": "",
      "slug": "brianpoole"
    },
    "xavierwoods": {
      "name": "Xavier Woods",
      "position": "CB",
      "age": "25",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Physical cornerback who is good in run support.",
      "stats_2020": "72 tackles, 0 INTs, 1 pass breakup",
      "org_2020": "Cowboys",
      "signed": "",
      "rfa": "",
      "slug": "xavierwoods"
    },
    "ronalddarby": {
      "name": "Ronald Darby",
      "position": "CB",
      "age": "27",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Played in 96 percent of snaps last year and was solid in coverage.",
      "stats_2020": "55 tackles, 0 INTs, 16 pass breakups",
      "org_2020": "Washington",
      "signed": "broncos",
      "rfa": "",
      "slug": "ronalddarby"
    },
    "quintondunbar": {
      "name": "Quinton Dunbar",
      "position": "CB",
      "age": "28",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Played in just six games last year but is one of the biggest corners available.",
      "stats_2020": "30 tackles, 1 INT, 5 pass breakups",
      "org_2020": "Seahawks",
      "signed": "",
      "rfa": "",
      "slug": "quintondunbar"
    },
    "troyhill": {
      "name": "Troy Hill",
      "position": "CB",
      "age": "29",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Started 16 games for the first time and had two pick-sixes in 2020.",
      "stats_2020": "77 tackles, 3 INTs, 10 pass breakups",
      "org_2020": "Rams",
      "signed": "browns",
      "rfa": "",
      "slug": "troyhill"
    },
    "xavierrhodes": {
      "name": "Xavier Rhodes",
      "position": "CB",
      "age": "30",
      "type": "free agent",
      "bucket": "medium",
      "salary": 7,
      "synopsis": "Started all 16 games last year but his play has dropped off considerably.",
      "stats_2020": "42 tackles, 2 INTs, 12 pass breakups",
      "org_2020": "Colts",
      "signed": "colts",
      "rfa": "",
      "slug": "xavierrhodes"
    },
    "kevinking": {
      "name": "Kevin King",
      "position": "CB",
      "age": "25",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Don\u2019t watch his tape from the NFC Championship game.",
      "stats_2020": "57 tackles, 0 INTs, 5 pass breakups",
      "org_2020": "Packers",
      "signed": "packers",
      "rfa": "",
      "slug": "kevinking"
    },
    "michaeldavis": {
      "name": "Michael Davis",
      "position": "CB",
      "age": "26",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Has good size and developed into a nice starter over the past two years.",
      "stats_2020": "64 tackles, 3 INTs, 14 pass breakups",
      "org_2020": "Chargers",
      "signed": "chargers",
      "rfa": "",
      "slug": "michaeldavis"
    },
    "busterskrine": {
      "name": "Buster Skrine",
      "position": "CB",
      "age": "31",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Productive slot corner who has missed only nine games in 10 seasons.",
      "stats_2020": "66 tackles, 0 INTs, 3 pass breakups",
      "org_2020": "Bears",
      "signed": "",
      "rfa": "",
      "slug": "busterskrine"
    },
    "jasonverrett": {
      "name": "Jason Verrett",
      "position": "CB",
      "age": "29",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Started 13 games last year, but has battled injuries his whole career.",
      "stats_2020": "60 tackles, 2 INTs, 7 pass breakups",
      "org_2020": "49ers",
      "signed": "49ers",
      "rfa": "",
      "slug": "jasonverrett"
    },
    "mackensiealexander": {
      "name": "Mackensie Alexander",
      "position": "CB",
      "age": "27",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Was solid in Minnesota but didn\u2019t make a big impact last year in Cincinnati.",
      "stats_2020": "47 tackles, 1 INT, 6 pass breakups",
      "org_2020": "Bengals",
      "signed": "",
      "rfa": "",
      "slug": "mackensiealexander"
    },
    "terrancemitchell": {
      "name": "Terrance Mitchell",
      "position": "CB",
      "age": "28",
      "type": "free agent",
      "bucket": "medium",
      "salary": 5,
      "synopsis": "Coming off a career year with 16 starts and three forced fumbles.",
      "stats_2020": "65 tackles, 0 INTs, 13 pass breakups",
      "org_2020": "Browns",
      "signed": "texans",
      "rfa": "",
      "slug": "terrancemitchell"
    },
    "jcjackson": {
      "name": "J.C. Jackson",
      "position": "CB",
      "age": "25",
      "type": "free agent",
      "bucket": "low",
      "salary": 5,
      "synopsis": "Has 17 interceptions in three seasons and will cost about $5 million on a first-round tender.",
      "stats_2020": "40 tackles, 9 INTs, 14 pass breakups",
      "org_2020": "Patriots",
      "signed": "",
      "rfa": "x",
      "slug": "jcjackson"
    },
    "nickmullens": {
      "name": "Nick Mullens",
      "position": "QB",
      "age": "25",
      "type": "free agent",
      "bucket": "low",
      "salary": 4,
      "synopsis": "Has had some decent games among his 16 NFL starts.",
      "stats_2020": "2,437 yards, 12 TDs, 12 INTs",
      "org_2020": "49ers",
      "signed": "",
      "rfa": "x",
      "slug": "nickmullens"
    },
    "nickellrobeycoleman": {
      "name": "Nickell Robey-Coleman",
      "position": "CB",
      "age": "29",
      "type": "free agent",
      "bucket": "low",
      "salary": 4,
      "synopsis": "Eight-year veteran is a good depth piece at nickel corner.",
      "stats_2020": "44 tackles, 0 INTs, 1 pass breakup",
      "org_2020": "Eagles",
      "signed": "",
      "rfa": "",
      "slug": "nickellrobeycoleman"
    },
    "darquezedennard": {
      "name": "Darqueze Dennard",
      "position": "CB",
      "age": "29",
      "type": "free agent",
      "bucket": "low",
      "salary": 4,
      "synopsis": "Former first-round pick has struggled and missed 15 games the last two years.",
      "stats_2020": "36 tackles, 1 INT, 5 pass breakups",
      "org_2020": "Falcons",
      "signed": "",
      "rfa": "",
      "slug": "darquezedennard"
    },
    "jasonmccourty": {
      "name": "Jason McCourty",
      "position": "CB",
      "age": "33",
      "type": "free agent",
      "bucket": "low",
      "salary": 4,
      "synopsis": "Has been a nice addition for the Patriots the last three years. Do they want him back for a fourth?",
      "stats_2020": "42 tackles, 0 INTs, 3 pass breakups",
      "org_2020": "Patriots",
      "signed": "",
      "rfa": "",
      "slug": "jasonmccourty"
    },
    "gareonconley": {
      "name": "Gareon Conley",
      "position": "CB",
      "age": "25",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "Former first-round pick spent all of last year on injured reserve.",
      "stats_2020": "N/A",
      "org_2020": "Texans",
      "signed": "",
      "rfa": "",
      "slug": "gareonconley"
    },
    "cameronsutton": {
      "name": "Cameron Sutton",
      "position": "CB",
      "age": "26",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "Got first real starting experience in 2020 and can be a good depth piece.",
      "stats_2020": "30 tackles, 1 INT, 8 pass breakups",
      "org_2020": "Steelers",
      "signed": "",
      "rfa": "",
      "slug": "cameronsutton"
    },
    "bashaudbreeland": {
      "name": "Bashaud Breeland",
      "position": "CB",
      "age": "29",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "Seven-year veteran offers good depth on the outside.",
      "stats_2020": "38 tackles, 2 INTs, 9 pass breakups",
      "org_2020": "Chiefs",
      "signed": "",
      "rfa": "",
      "slug": "bashaudbreeland"
    },
    "k\u2019waunwilliams": {
      "name": "K\u2019Waun Williams",
      "position": "CB",
      "age": "29",
      "type": "free agent",
      "bucket": "low",
      "salary": 3,
      "synopsis": "Slot cornerback limited to eight games last year with a knee injury.",
      "stats_2020": "22 tackles, 0 INTs, 4 pass breakups",
      "org_2020": "49ers",
      "signed": "",
      "rfa": "",
      "slug": "k\u2019waunwilliams"
    },
    "anthonyharris": {
      "name": "Anthony Harris",
      "position": "S",
      "age": "29",
      "type": "free agent",
      "bucket": "high",
      "salary": 15,
      "synopsis": "A tackling machine and key part of the Vikings\u2019 defense.",
      "stats_2020": "104 tackles, 0 INTs, 7 pass breakups",
      "org_2020": "Vikings",
      "signed": "eagles",
      "rfa": "",
      "slug": "anthonyharris"
    },
    "johnjohnson": {
      "name": "John Johnson",
      "position": "S",
      "age": "25",
      "type": "free agent",
      "bucket": "high",
      "salary": 15,
      "synopsis": "Has developed into an excellent strong safety and should get a huge contract.",
      "stats_2020": "105 tackles, 1 INT, 8 pass breakups",
      "org_2020": "Rams",
      "signed": "browns",
      "rfa": "",
      "slug": "johnjohnson"
    },
    "lamarcusjoyner": {
      "name": "Lamarcus Joyner",
      "position": "S",
      "age": "30",
      "type": "free agent",
      "bucket": "medium",
      "salary": 6,
      "synopsis": "Undersized but can play cornerback or safety.",
      "stats_2020": "66 tackles, 0 INTs, 5 pass breakups",
      "org_2020": "Raiders",
      "signed": "jets",
      "rfa": "",
      "slug": "lamarcusjoyner"
    },
    "duronharmon": {
      "name": "Duron Harmon",
      "position": "S",
      "age": "30",
      "type": "free agent",
      "bucket": "medium",
      "salary": 5,
      "synopsis": "Started all 16 games last year but struggled with his new team.",
      "stats_2020": "73 tackles, 2 INTs, 5 pass breakups",
      "org_2020": "Lions",
      "signed": "",
      "rfa": "",
      "slug": "duronharmon"
    },
    "jaquiskitartt": {
      "name": "Jaquiski Tartt",
      "position": "S",
      "age": "29",
      "type": "free agent",
      "bucket": "medium",
      "salary": 5,
      "synopsis": "Suffered multiple injuries in 2020 and is probably just a depth piece now.",
      "stats_2020": "30 tackles, 1 INT, 4 pass breakups",
      "org_2020": "49ers",
      "signed": "",
      "rfa": "",
      "slug": "jaquiskitartt"
    },
    "keanuneal": {
      "name": "Keanu Neal",
      "position": "S",
      "age": "25",
      "type": "free agent",
      "bucket": "low",
      "salary": 4,
      "synopsis": "Former first-round pick has struggled with injuries but played in 15 games in 2020.",
      "stats_2020": "100 tackles, 1 INT, 2 pass breakups",
      "org_2020": "Falcons",
      "signed": "cowboys",
      "rfa": "",
      "slug": "keanuneal"
    },
    "malikhooker": {
      "name": "Malik Hooker",
      "position": "S",
      "age": "24",
      "type": "free agent",
      "bucket": "low",
      "salary": 4,
      "synopsis": "Was becoming a great player for the Colts but tore an Achilles' tendon in September.",
      "stats_2020": "7 tackles, 0 INTs, 0 pass breakups",
      "org_2020": "Colts",
      "signed": "",
      "rfa": "",
      "slug": "malikhooker"
    },
    "macjones": {
      "name": "Mac Jones",
      "position": "QB",
      "age": "22",
      "type": "draft",
      "bucket": "",
      "salary": 0,
      "synopsis": "Put up huge numbers in 2020, but was that just because he plays for Alabama?",
      "stats_2020": "4,500 yards, 41 TDs, 4 INTs",
      "org_2020": "Alabama",
      "signed": "",
      "rfa": "",
      "slug": "macjones"
    },
    "devontasmith": {
      "name": "DeVonta Smith",
      "position": "WR",
      "age": "22",
      "type": "draft",
      "bucket": "",
      "salary": 0,
      "synopsis": "Heisman Trophy winner has tremendous hands and route-running skills, but may be too undersized.",
      "stats_2020": "1,856 receiving yards, 23 TDs, 117 catches",
      "org_2020": "Alabama",
      "signed": "",
      "rfa": "",
      "slug": "devontasmith"
    },
    "christiandarrisaw": {
      "name": "Christian Darrisaw",
      "position": "OT",
      "age": "21",
      "type": "draft",
      "bucket": "",
      "salary": 0,
      "synopsis": "Has good size and could potentially be an immediate starter at left tackle.",
      "stats_2020": "N/A",
      "org_2020": "Virginia Tech",
      "signed": "",
      "rfa": "",
      "slug": "christiandarrisaw"
    },
    "rashawnslater": {
      "name": "Rashawn Slater",
      "position": "OT",
      "age": "21",
      "type": "draft",
      "bucket": "",
      "salary": 0,
      "synopsis": "Might be better suited for guard, but a tremendous and versatile athlete. ",
      "stats_2020": "N/A",
      "org_2020": "Northwestern",
      "signed": "",
      "rfa": "",
      "slug": "rashawnslater"
    },
    "jaelanphillips": {
      "name": "Jaelan Phillips",
      "position": "DT",
      "age": "21",
      "type": "draft",
      "bucket": "",
      "salary": 0,
      "synopsis": "A raw prospect who has great measurables and had eight sacks in 2020.",
      "stats_2020": "45 tackles, 8 sacks, 0 forced fumbles",
      "org_2020": "Miami",
      "signed": "",
      "rfa": "",
      "slug": "jaelanphillips"
    },
    "kwitypaye": {
      "name": "Kwity Paye",
      "position": "DT",
      "age": "22",
      "type": "draft",
      "bucket": "",
      "salary": 0,
      "synopsis": "Rhode Island native who played only four games in 2020 but has elite tools.",
      "stats_2020": "16 tackles, 2 sacks, 0 forced fumbles",
      "org_2020": "Michigan",
      "signed": "",
      "rfa": "",
      "slug": "kwitypaye"
    },
    "gregoryrousseau": {
      "name": "Gregory Rousseau",
      "position": "DE/OLB",
      "age": "20",
      "type": "draft",
      "bucket": "",
      "salary": 0,
      "synopsis": "Sat out 2020 and played only one full year, but his potential is off the charts. ",
      "stats_2020": "N/A",
      "org_2020": "Miami",
      "signed": "",
      "rfa": "",
      "slug": "gregoryrousseau"
    },
    "zavencollins": {
      "name": "Zaven Collins",
      "position": "LB",
      "age": "21",
      "type": "draft",
      "bucket": "",
      "salary": 0,
      "synopsis": "An big, explosive athlete who can drop into coverage and chase down ballcarriers.",
      "stats_2020": "54 tackles, 4 sacks, 2 forced fumbles",
      "org_2020": "Tulsa",
      "signed": "",
      "rfa": "",
      "slug": "zavencollins"
    },
    "jeremiahowusukoramoah": {
      "name": "Jeremiah Owusu-Koramoah",
      "position": "LB",
      "age": "21",
      "type": "draft",
      "bucket": "",
      "salary": 0,
      "synopsis": "An undersized but speedy ballhawk who won the Butkus Award as the nation\u2019s top linebacker.",
      "stats_2020": "62 tackles, 1.5 sacks, 3 forced fumbles",
      "org_2020": "Notre Dame",
      "signed": "",
      "rfa": "",
      "slug": "jeremiahowusukoramoah"
    },
    "tysoncampbell": {
      "name": "Tyson Campbell",
      "position": "CB",
      "age": "21",
      "type": "draft",
      "bucket": "",
      "salary": 0,
      "synopsis": "Another lengthy cornerback who could do well in a press-man defense.",
      "stats_2020": "29 tackles, 1 INT, 5 pass breakups",
      "org_2020": "Georgia",
      "signed": "",
      "rfa": "",
      "slug": "tysoncampbell"
    },
    "calebfarley": {
      "name": "Caleb Farley",
      "position": "CB",
      "age": "22",
      "type": "draft",
      "bucket": "",
      "salary": 0,
      "synopsis": "Didn\u2019t play in 2020, but a big, physical cornerback in a draft that doesn\u2019t have many of them.",
      "stats_2020": "N/A",
      "org_2020": "Virginia Tech",
      "signed": "",
      "rfa": "",
      "slug": "calebfarley"
    },
    "patricksurtainii": {
      "name": "Patrick Surtain II",
      "position": "CB",
      "age": "20",
      "type": "draft",
      "bucket": "",
      "salary": 0,
      "synopsis": "Tall, rangy cornerback who started for three seasons and dominated at Alabama.",
      "stats_2020": "37 tackles, 1 INT, 9 pass breakups",
      "org_2020": "Alabama",
      "signed": "",
      "rfa": "",
      "slug": "patricksurtainii"
    }
  }
}

export default data;